import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import Box from "../../../../node_modules/@mui/system/esm/Box/Box.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
const BoxWrapper = styled(Box, styledOptions)(({
  disablepadding = false
}) => ({
  padding: disablepadding ? "inherit" : Spacing["1000"]
}));
const LeftSlotWrapper = styled("div")({
  minWidth: Spacing["3500"]
});
export {
  BoxWrapper,
  LeftSlotWrapper
};
//# sourceMappingURL=containers.es.js.map
